import { constants } from "./general";
import { logAuth, logError, LogCategory } from "./sentryLogger";

const CLASSLINK_CLIENT_ID = process.env.REACT_APP_CLASSLINK_CLIENT_ID;
export const CLASSLINK_OAUTH_STATE_KEY = "classlink_oauth_state";
export const CLASSLINK_OAUTH_ORIGINAL_PATH = "classlink_oauth_original_path";

const CLASSLINK_AUTHORIZE_URL = "https://launchpad.classlink.com/oauth2/v2/auth";

export const initiateClassLinkSignIn = async (redirectUri, additionalState = {}) => {
  const currentPath = window.location.pathname + window.location.search;
  const destination = redirectUri || currentPath;
  const isEducator = additionalState.isEducator || false;
  const hasGroupCode = !!additionalState.groupCode;

  try {
    if (!CLASSLINK_CLIENT_ID) {
      const error = new Error("ClassLink Client ID is not configured");
      logError("ClassLink OAuth initiation failed - missing client ID", error, {
        category: LogCategory.AUTH,
        authMethod: constants.CLASSLINK,
        originPath: currentPath,
        destination,
      });
      return { success: false, error };
    }

    logAuth("OAuth initiation started", {
      authMethod: constants.CLASSLINK,
      originPath: currentPath,
      destination,
      isEducator,
      hasGroupCode,
    });

    localStorage.setItem(CLASSLINK_OAUTH_ORIGINAL_PATH, currentPath);
    const state = JSON.stringify({
      nonce: Math.random().toString(36).substring(2),
      destination,
      provider: constants.CLASSLINK,
      ...additionalState,
    });
    localStorage.setItem(CLASSLINK_OAUTH_STATE_KEY, state);

    const oauthUrl = new URL(CLASSLINK_AUTHORIZE_URL);
    oauthUrl.searchParams.append("client_id", CLASSLINK_CLIENT_ID);
    oauthUrl.searchParams.append("redirect_uri", `${window.location.origin}/auth/callback`);
    oauthUrl.searchParams.append("response_type", "code");
    oauthUrl.searchParams.append("scope", "openid email profile");
    oauthUrl.searchParams.append("state", state);

    window.location.href = oauthUrl.toString();
    return { success: true };
  } catch (e) {
    logError("ClassLink OAuth initiation failed", e, {
      category: LogCategory.AUTH,
      authMethod: constants.CLASSLINK,
      originPath: currentPath,
      destination,
    });
    return { success: false, error: e };
  }
};
